import { NotifyHelper } from "../../../helpers/toast"
import { eRoleActionsObj } from "../../action-types/user/IRoleActionTypes"
import { generateActionForKey, generateActions } from "../generateActions"

export const roleAction = {
    ...generateActions(eRoleActionsObj, "ROLE"),
    ...generateActionForKey(eRoleActionsObj, "ROLE", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eRoleActionsObj, "ROLE", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eRoleActionsObj, "ROLE", "SAVE_ERRR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eRoleActionsObj, "ROLE", "DELETE_ERRR", (m) => { NotifyHelper.Error(m) }),
}